import { useCallback, useMemo } from 'react';
import Input from 'app/componentsV2/Input/Input';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { ICourseNodeDAO } from 'types/domain/course';
import CourseNodeStatusToggle from 'app/features/Course/CourseNode/CourseNodeStatusToggle';
import { useCopyLink } from 'core/hooks/useCopyLink';
import { H5 } from 'app/componentsV2/Typography/Typography';
import CourseNodeShare from '../../Course/CourseNode/Share/CourseNodeShare';

interface ModuleShareProps {
  courseNode: ICourseNodeDAO;
}

const COMPONENT_ID_LEARNERS = 'module-share-learners';
export const COMPONENT_ID_ADD_LEARNER = 'module-share-add-learner';

const ModuleShare: React.FC<ModuleShareProps> = ({ courseNode }) => {
  const { copyLinkToClipboard } = useCopyLink();
  const domain = /:\/\/([^/]+)/.exec(window.location.href)?.[1] || 'devco';

  const shareUrl = useMemo(() => {
    if (courseNode) return `https://${domain}/en/${courseNode?.prettyToken ?? courseNode?.token}`;
    return null;
  }, [courseNode, domain]);

  const onCopyUrl = useCallback(() => {
    if (shareUrl) copyLinkToClipboard(shareUrl);
  }, [shareUrl, copyLinkToClipboard]);

  return (
    <>
      <div className="flex items-center mb-10">
        <Input readOnly autoResize label="Copy this link to share" variant="form" value={shareUrl} />
        <ClipboardDocumentIcon
          onClick={onCopyUrl}
          className="w-6 h-6 ml-2 mr-2 hover:text-gray-500 hover:border hover:border-white rounded cursor-pointer"
        />
      </div>
      <H5 className="my-5">Access status</H5>
      <CourseNodeStatusToggle courseNode={courseNode} className="my-5" />

      <CourseNodeShare
        className="mt-10 flex flex-col sm:flex-row w-full gap-10"
        courseNodeId={courseNode?.id}
        courseId={courseNode?.courseId}
        componentId={COMPONENT_ID_LEARNERS}
        typeaheadComponentId={COMPONENT_ID_ADD_LEARNER}
      />
    </>
  );
};

export default ModuleShare;
